import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import { createRouter, createWebHashHistory } from 'vue-router';
import { sync } from 'vuex-router-sync'
import PuriCampaign from '../component/view/PuriCampaign.vue'
import ErrorNotFound from '../component/pages/ErrorNotFound.vue'
import {sendViewEvent} from "../util/Ga4EventUtil";

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/error'
        },
        {
            path: '/error',
            name: 'error',
            component: ErrorNotFound,
            props: route => ({
                unsavedPuriCount: unsavedPuriCount,
                latestImageId: latestImageId
            })
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: { name: 'error' }
        }
    ]
});

router.afterEach((to, from) => {
    sendViewEvent(to.path)
})

// 初期化時にstoreをセットすることでnavigation guard発動のたびにAPI呼んでしまうのを防ぐ
sync(Store, router);
Promise.all([
    Store.dispatch('AccountStoreV2/getAccountStatus')
]).then(() => {
    createApp(PuriCampaign)
        .use(Store)
        .use(router)
        .mount('#puriCampaign');
});
